import { computed, inject } from '@angular/core';
import { recordAssistantUsage } from '../telemetry/otel';
import { Router } from '@angular/router';
import { provideEgAssistantGuideHost, provideEgAssistantHost, provideEgAssistantUsage, provideEgAssistantUser, provideEgInternalGptAdapter } from '@expertgroup/assistant';
import { CopyService } from '@/app/core/copy/copy.service';
import { CurrentUserService } from '@/app/core/current-user/current-user.service';

/** Only local host code resolves navigation and DOM targets; guide prose is owned by GPT. */
export const protaxAssistantHostProviders = [
    provideEgAssistantUsage(recordAssistantUsage),
    provideEgAssistantHost(() => {
        const t = inject(CopyService).t;
        return {
            schemaVersion: 1,
            id: 'protax',
            name: t('assistant.name'),
            appName: 'ProTax',
            launcherLabel: t('assistant.launcher'),
            panelWidth: 420,
            defaultChat: 'protax',
            explainChat: 'protax',
            chats: [{ id: 'protax', label: t('assistant.chat'), adapterId: 'gpt-protax', description: t('assistant.introduction') }]
        };
    }),
    provideEgInternalGptAdapter('gpt-protax', { moduleKey: 'protax' }),
    // The avatar next to each question (0.23): the same initials as the user menu in the top bar. `null` while the
    // actor is unknown, which the library draws as its person glyph rather than an empty circle.
    provideEgAssistantUser(() => {
        const user = inject(CurrentUserService);
        return { initials: computed(() => user.initials() || null) };
    }),
    provideEgAssistantGuideHost(() => {
        const router = inject(Router);
        const element = (id: string) => () => document.querySelector<HTMLElement>(`[data-eg-guide="${id}"]`);
        return {
            id: 'protax',
            targets: [
                {
                    id: 'properties-import',
                    element: element('properties-import'),
                    prepare: async () => {
                        await router.navigateByUrl('/aplikacija/pregled-nepokretnosti');
                    }
                },
                { id: 'properties-template', element: element('properties-template') },
                { id: 'properties-file', element: element('properties-file') },
                { id: 'properties-review', element: element('properties-review') },
                { id: 'properties-commit', element: element('properties-commit') }
            ]
        };
    })
];
